import { request } from "./client";
import type { ProductDetail } from "./products";

export const serviceFields = [
  { key: "shippingLeadTime", label: "生产周期", max: 100 },
  { key: "shippingDescription", label: "生产与发货说明", max: 500 },
  { key: "freeShippingDescription", label: "定制运费说明", max: 500 },
  { key: "guaranteeDescription", label: "售后保障", max: 500 },
  { key: "invoiceDescription", label: "发票说明", max: 500 },
] as const;
export type ServiceField = typeof serviceFields[number]["key"];
export type ServiceValues = Record<ServiceField, string | null>;
export interface ServiceTemplate {
  id: string; name: string; active: boolean; version: number; fields: ServiceValues;
  linkedProducts: Array<{ id: string; name: string }>;
}
export interface ServiceBinding {
  templateId: string; templateName: string; templateVersion: number; available: boolean;
  inheritFields: ServiceField[]; effective: ServiceValues;
}
export async function listServiceTemplates() {
  return (await request<{ enabled: boolean; items: ServiceTemplate[] }>("/admin/products/service-templates")).data;
}
export async function saveServiceTemplate(template: ServiceTemplate, create: boolean) {
  const body = create ? { id: template.id, name: template.name, active: template.active, fields: template.fields }
    : { name: template.name, active: template.active, fields: template.fields, expectedVersion: template.version,
      expectedLinkedProductIds: template.linkedProducts.map((product) => product.id) };
  await request(create ? "/admin/products/service-templates" : `/admin/products/service-templates/${template.id}`, {
    method: create ? "POST" : "PATCH", body: JSON.stringify(body),
  });
}
export async function saveServiceBinding(product: ProductDetail, template: ServiceTemplate | undefined, inheritFields: ServiceField[]) {
  return (await request<ProductDetail>(`/admin/products/${product.id}/service-template`, {
    method: "PUT", body: JSON.stringify({ expectedUpdatedAt: product.updatedAt,
      templateId: template?.id ?? null, expectedTemplateVersion: template?.version ?? null,
      inheritFields: template ? inheritFields : [] }),
  })).data;
}
